import React from "react"
import { useSearchParams } from "react-router-dom"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"
import {
  THEME_LAYOUT_APP_WINDOW_CONTENT_PARAM,
  USE_THEME_LAYOUT_MODAL_HOST,
} from "@/pages/TrackingPage/DisplayOptions/components/themeLayoutAppWindow"
import ThemeLayoutAppWindowHost from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutAppWindowHost"
import ThemeLayoutCustomizePageContent from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutCustomizePageContent"
import ThemeLayoutModalHost from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutModalHost"
import { isShopifyEmbedded } from "@/utils/appBridge"

/**
 * /tracking-page/customizeBackdrop
 * - 商户 Shopify 嵌入（`isShopifyEmbedded() && !window.isFromAdmin`）：主文档挂载弹窗壳；仅弹窗内 iframe 带参渲染正文。
 *   弹窗壳的实现由 USE_THEME_LAYOUT_MODAL_HOST 决定（Modal 备用方案 / s-app-window 原方案）。
 * - 非嵌入 / 超管 isFromAdmin（同为 embedded 但不走弹窗壳）：全屏编辑。
 */
const CustomizeBackdropPage = () => {
  const [searchParams] = useSearchParams()
  const isAppWindowContentFrame = searchParams.get(THEME_LAYOUT_APP_WINDOW_CONTENT_PARAM) === "1"
  const isShopifyMerchantEmbedded = isShopifyEmbedded() && !window.isFromAdmin

  if (!isShopifyMerchantEmbedded || isAppWindowContentFrame) {
    return <ThemeLayoutCustomizePageContent variant={ThemeLayoutEnum.BACKDROP} />
  }

  return USE_THEME_LAYOUT_MODAL_HOST
    ? <ThemeLayoutModalHost subPath="customizeBackdrop" />
    : <ThemeLayoutAppWindowHost subPath="customizeBackdrop" />
}

export default CustomizeBackdropPage
